<template>
  <el-row>
    <el-col :span="12" class="p-r-sm">
      <el-form-item :prop="prop[0]">
        <el-select
          clearable
          filterable
          :value="value.length ? value[0] : ''"
          @change="(val) => handleChange(val, true)"
        >
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="12" class="p-l-sm">
      <el-form-item :prop="prop[1]">
        <el-input
          clearable
          class="inputWidth"
          :controls="false"
          v-bind="$attrs"
          :value="value.length ? value[1] : ''"
          @input="handleChange"
          type="number"
          v-if="inputType == 'inputNumber'"
        >
        </el-input>
        <el-input
          v-else
          clearable
          class="inputWidth"
          v-bind="$attrs"
          @input="handleChange"
          :value="value.length ? value[1] : ''"
        >
        </el-input>
      </el-form-item>
    </el-col>
  </el-row>
</template>

<script>
  export default {
    props: {
      value: {
        type: Array,
        default: () => [],
      },
      options: {
        type: Array,
        default: () => [],
      },
      inputType: {
        type: String,
        default: 'inputNumber',
      },
      prop: {
        // 可选，绑定form-item的prop
        type: Array,
        default: () => [],
      },
    },
    methods: {
      handleChange(val, select) {
        const value = this.value || [];
        if (select) {
          value[0] = val;
          if (!val) value[1] = '';
        } else {
          value[1] = val;
        }
        this.$emit('input', value);
      },
    },
  };
</script>
